/**
 * Service Pills
 * Inline pill+panel UI for staal/zichtservice on PDP. Reuses the existing
 * ServiceRequestManager (sample-request.js) for storage and add/remove —
 * this script only handles open/close, status text, and pill checkmark sync.
 */
(function () {
  'use strict';

  if (window.__servicePillsInit) return;
  window.__servicePillsInit = true;

  var SERVICES = {
    staal: {
      storageKey: 'vkw_sample_request',
      eventAdded: 'sampleRequest:added',
      eventRemoved: 'sampleRequest:removed',
      managerKey: 'sampleRequest',
      settingsKey: 'sampleRequestSettings',
      defaultMax: 7
    },
    zichtservice: {
      storageKey: 'vkw_viewing_service',
      eventAdded: 'viewingService:added',
      eventRemoved: 'viewingService:removed',
      managerKey: 'viewingService',
      settingsKey: 'viewingServiceSettings',
      defaultMax: 5
    }
  };

  function readItems(storageKey) {
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function getMaxItems(serviceKey) {
    var cfg = SERVICES[serviceKey];
    var settings = window[cfg.settingsKey];
    if (settings && typeof settings.maxItems === 'number' && settings.maxItems > 0) {
      return settings.maxItems;
    }
    var manager = window[cfg.managerKey];
    if (manager && typeof manager.MAX_ITEMS === 'number') {
      return manager.MAX_ITEMS;
    }
    return cfg.defaultMax;
  }

  function getItems(serviceKey) {
    var cfg = SERVICES[serviceKey];
    var manager = window[cfg.managerKey];
    if (manager && Array.isArray(manager.items)) return manager.items;
    return readItems(cfg.storageKey);
  }

  function formatTemplate(template, vars) {
    if (!template) return '';
    return template
      .replace('__COUNT__', vars.count)
      .replace('{{ count }}', vars.count)
      .replace('__MAX__', vars.max)
      .replace('{{ max }}', vars.max);
  }

  function ServicePills(root) {
    this.root = root;
    this.productId = root.getAttribute('data-product-id');
    this.pills = root.querySelectorAll('[data-service-pill]');
    this.panels = root.querySelectorAll('[data-service-pill-panel]');
    this.bind();
    this.refreshAll();
  }

  ServicePills.prototype.bind = function () {
    var self = this;

    this.pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        var key = pill.getAttribute('data-service-pill');
        self.togglePanel(key);
      });
    });

    this.root.querySelectorAll('[data-service-pill-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.closeAllPanels();
      });
    });

    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeAllPanels();
    });

    Object.keys(SERVICES).forEach(function (key) {
      var cfg = SERVICES[key];
      document.addEventListener(cfg.eventAdded, function () { self.refresh(key); });
      document.addEventListener(cfg.eventRemoved, function () { self.refresh(key); });
    });
  };

  ServicePills.prototype.togglePanel = function (key) {
    var pill = this.root.querySelector('[data-service-pill="' + key + '"]');
    var panel = this.root.querySelector('[data-service-pill-panel="' + key + '"]');
    if (!pill || !panel) return;

    var isOpen = pill.getAttribute('aria-expanded') === 'true';
    this.closeAllPanels();

    if (!isOpen) {
      pill.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
  };

  ServicePills.prototype.closeAllPanels = function () {
    this.pills.forEach(function (p) { p.setAttribute('aria-expanded', 'false'); });
    this.panels.forEach(function (panel) { panel.hidden = true; });
  };

  ServicePills.prototype.refresh = function (key) {
    var pill = this.root.querySelector('[data-service-pill="' + key + '"]');
    var panel = this.root.querySelector('[data-service-pill-panel="' + key + '"]');
    if (!pill && !panel) return;

    var items = getItems(key);
    var max = getMaxItems(key);
    var count = items.length;
    var inList = items.some(function (item) {
      return String(item.productId) === String(this.productId);
    }.bind(this));

    if (pill) {
      pill.classList.toggle('is-active', inList);
    }

    if (panel) {
      var statusEl = panel.querySelector('[data-service-pill-status]');
      var strings = window.servicePillsStrings || {};

      if (statusEl) {
        var label = inList
          ? (statusEl.getAttribute('data-in-list') || strings.inList || '')
          : (statusEl.getAttribute('data-not-in-list') || strings.notInList || '');
        var countText = formatTemplate(strings.count || '', { count: count, max: max });
        statusEl.textContent = label + ' · ' + countText;
        statusEl.classList.toggle('is-in-list', inList);
      }
    }
  };

  ServicePills.prototype.refreshAll = function () {
    var self = this;
    Object.keys(SERVICES).forEach(function (key) { self.refresh(key); });
  };

  function init() {
    document.querySelectorAll('[data-service-pills]').forEach(function (root) {
      if (root.__inited) return;
      root.__inited = true;
      new ServicePills(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
